import { __css } from "@fluentui/react-components";
const useVisuallyHiddenStyles = __css({"hidden":{"qhf8xq":"f1euv43f","a9b677":"frkrog8","Bqenvij":"f1mpe4l3","Bo78w4l":0,"Cgygva":0,"yil37a":"f1t6u27w","Bokbzmb":0,"Jyy4pa":0,"B1u1w3b":"f7trie0","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fx1xsyp","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fgdu4nw","B68tc82":"f1p9o1ba","Bmxbyg5":"f1sil6mw","Bh84pgu":"f1w1vubc","Huce71":"fz5stix","B4j52fo":"fre7gi1","Bn0qgzm":"fqdk4by","B4m11q7":"f1ea0rl6","tzxy30":"fl6yf4s"}});
export {
  useVisuallyHiddenStyles
};
//# sourceMappingURL=styles.js.map

import "/opt/batiflow/app/packages/ui/dist/components/internal/styles.griffel.css";